export default [
    {
        path: '/permission-set',
        name: 'permission_set',
        component: () => import('@/views/permission-set/index.vue')
    },
    {
        path: '/permission-set/add',
        name: 'permission_set_add',
        component: () => import('@/views/permission-set-details/index.vue')
    },
    {
        path: '/permission-set/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'permission_sets_uuid',
                component: () => import('@/views/permission-set-details/index.vue')
            },
            {
                path: 'edit',
                name: 'permission_sets_uuid_edit',
                component: () => import('@/views/permission-set-details/index.vue')
            },
            {
                path: 'duplicate',
                name: 'permission_sets_uuid_duplicate',
                component: () => import('@/views/permission-set-details/index.vue')
            },
            {
                path: 'view',
                name: 'permission_sets_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            }
        ]
    }
];
